module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACBSURBVEhL7ZRhCsAgCEa73Y4+xm6xHWTzYwhWTrEV7EcPHhmk/jBMkwg7eX1wI020pKgmWkJUcJDLE+ZoCVEBTjSpKB+3CGScgSHJx1FXEvB9GP9tgJ+B4XEBS3XIHiepFSt9/aYeXGAYQxvIPeXunBa4ONud2cBF7ineOZMepHQD7k+g1h4VbA4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-paint-roller/dark/24.png
// module id = 2308
// module chunks = 2